import { render, staticRenderFns } from "./readingOrder.vue?vue&type=template&id=8ffe21f2&scoped=true"
import script from "./readingOrder.vue?vue&type=script&lang=js"
export * from "./readingOrder.vue?vue&type=script&lang=js"
import style0 from "./readingOrder.vue?vue&type=style&index=0&id=8ffe21f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffe21f2",
  null
  
)

export default component.exports